// extracted by mini-css-extract-plugin
module.exports = {"footerDiv":"Footer_footerDiv__11yg4","footerList":"Footer_footerList__1BUyZ"};